<template>
  <div v-loading="loading">
     <div class="listBtn" v-if="list">
        <p v-if="!testInfo.time" class="yellow">上传视频</p>
        <p  class="red" v-else-if="testInfo.status_name == '未通过' || testInfo.status_name == '待审核'">未通过/待审核</p>
        <p v-else @click="toView"  class="green">审核通过</p>
        <input @click="uploadData2" v-if="!status"/>
          <input type="file" ref="videoFile" accept=".mp4,.AVI,.mov,.rmvb,.rm,.FLV" @change="uploadData" v-else-if="status && (testInfo.status_name == '未上传' || testInfo.status_name == '待审核' || testInfo.status_name == '未通过')"/>
     </div>
     <div class="examin-content" v-else>
        <div class="examinTitle">{{ testInfo && testInfo.name }}</div>
        
        <div class="examinDesc" v-if="testInfo.time">
          上传时间：{{ testInfo.time }}
        </div>
      
      <div class="examinBtn">
        <p v-if="testInfo.status_name == '未上传'" >{{ testInfo.status_name }}</p>
        <p class="red" v-else-if="testInfo.status_name == '不通过'" >{{ testInfo.status_name }}</p>
        <p class="red" v-else-if="testInfo.status_name == '未通过' || testInfo.status_name == '待审核'" >{{ testInfo.status_name }}</p>
        <p class="green" v-else>{{ testInfo.status_name }}</p>
        <div class="btn">
          <p v-if="!testInfo.time"  class="yellow">上传视频</p>
          <p v-else-if="testInfo.status_name == '未通过' || testInfo.status_name == '待审核'" class="red">重新上传</p>
          <p v-else @click="toView"  class="green">查看视频</p>
          <input @click="uploadData2" v-if="!status"/>
          <input type="file" ref="videoFile" accept=".mp4,.AVI,.mov,.rmvb,.rm,.FLV" @change="uploadData" v-else-if="status && (testInfo.status_name == '未上传' || testInfo.status_name == '待审核' || testInfo.status_name == '未通过')"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["testInfo", "list"],
  data() {
    return {
      loading: false,
      form: {
        gender: 2,
        name: "",
        mobile: this.$store.state.user.mobile,
        cid: "",
        cover: "",
      },
      formImg:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formImg.jpg",
      radio:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formRadio.jpg",
      radio2:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formRadio2.jpg",
      infoSubmit: false,
      // testInfo:{
      //   exam_pass: 0,
      //   name:'试卷题目',
      //   score: 100,
      //   question_number: 10,
      //   pass: 0,
      //   exam_time: '2022-10-10 12:12:12'
      // },
      pass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/pass.jpg",
      noPass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/noPass.jpg",
    };
  },
  computed: {
    status(){
      let status = false
      if(this.list){
        status = this.list.length ? this.list.every(item=>{
          return item.study_status == 1 || item.speak.every(v=>{ return v.study_status == 1})
        }) : false
      }else{
        status = true
      }
      return this.testInfo.study_status == 1 || status
    },
    vipInfo() {
      return this.$store.state.vipInfo;
    },
    platName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    VIPShow() {
      return this.$store.state.VIPShow;
    },
   
  },
  mounted() {},
  methods: {
     gettime(video, size){
      const promise = new Promise(resolve => {
        video.addEventListener('canplaythrough', e => {
          console.log(58, e, e.target.duration, size)
          if (e.target.duration <= size) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
      return promise
    },
    async checkSize(files, size) {
      console.log(files)
      // console.log(56, Number.isNaN(Number(size)), size)
      if (!files) return false
      // 这一条是正式服务器不需要这段所以当size 为undefined 时默认 返回 true
      if (Number.isNaN(Number(size))) return true
      const checktimevideo = document.getElementById('checktimevideo')
      if (checktimevideo) {
        document.body.removeChild(checktimevideo)
      }
      const video = document.createElement('video')
      const url = URL.createObjectURL(files)
      video.src = url
      video.id = 'checktimevideo'
      video.style.display = 'none'

      document.body.appendChild(video)

      return await this.gettime(video, size)
    },
    uploadData2(){
      this.$toast("请完成所有课程再提交");
    },
    toView(){
      window.open(this.testInfo.video_url)
    },
    async uploadData(e) {
     let ifFit = await this.checkSize(e.target.files[0], 300)
     if(!ifFit){
      this.$toast("请上传5分钟内的视频");
      return
     }
     
      
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      if (file.size > 1024 * 1024 * 200) {
        this.$toast("请上传200M以内的视频");
        return;
      }
      console.log(file)
      let param = new FormData();
      param.append("folder", file);
      param.append("chapter_id", this.testInfo.id)
      param.append("token", localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).access_token : '')
      this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0,
      });
      this.$request.toUploadVideo(param).then((res) => {
        this.$refs.videoFile.value = ''
        if (res && res.code == 0) {
          this.form.cover = res.data.fullpath;
          this.$request.videoExamin({
            discipline_id: this.testInfo.discipline_id,
            url: res.data,
            chapter_id: this.testInfo.id,
            token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).access_token : ''
          }).then(res2=>{
            this.loading = false

            if(res2.code == 0){
              this.$emit('updata','video')
            }else{
              
              this.$toast(res.msg);
            }
          })
        } else {
          this.loading = false
          this.$toast(res.msg);
        }
      });
    },
    
    toPage() {
      if (!localStorage.getItem("user")) {
        this.$store.commit("changeLoginShow", true);
      } else {
        this.$router.push({
          path: "./detailVip",
          query: {
            id: this.vipInfo.goods_id,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.green{
  color: #3BD322 !important;
}
.red{
  color: #F33B2E !important;
}
.yellow{
  color: #F08E00 !important;
}
.listBtn{
  p{
    height: 80px;
    background: #FFFFFF;
    border-radius: 40px;
    line-height: 80px;
    text-align: center;
    font-size: 28px;
    font-weight: 500;
    margin: 32px 24px 0;
  }
  position: relative;
  input{
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}
.examin-content {
  width: calc(100vw - 64px);
  margin: 0 auto 20px;
  background: #F7F7F7;
  border-radius: 12px;
  overflow: hidden;
  padding: 32px 24px;
  font-size: 14px;
  box-sizing: border-box;
  color: #000000;
}
.examin-content .examinBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 8px;
  >p{
    font-size: 28px;
    font-weight: 500;
    color: #666666;
  }
  .btn {
    width: 160px;
    height: 64px;
    line-height: 64px;
    background: #FFFFFF;
    border-radius: 32px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    position: relative;
    input{
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }
}

.examin-content  .examinTitle {
  color: #000;
  width: 100%;
  font-size: 28px;
  margin-bottom: 8px;
  font-weight: 500;
  padding: 0;
}
.examin-content  .examinDesc {
  font-size: 20px;
  font-weight: 400;
  color: #999999;
  padding-bottom: 8px;
  line-height: 40px;
}
</style>
